
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import TimelinePage from '../pages/timeline/page';
import ExhibitionPage from '../pages/exhibition/page';
import RestorationPage from '../pages/restoration/page';
import AboutPage from '../pages/about/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/timeline',
    element: <TimelinePage />,
  },
  {
    path: '/exhibition',
    element: <ExhibitionPage />,
  },
  {
    path: '/restoration',
    element: <RestorationPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
